
import InnerPageTitle from '@/components/Shared/InnerPageTitle/index.vue'
import BookImage from './BookImage.vue'
import BookDescription from './BookDescription.vue'
import BookComments from './BookComments.vue'
import BookOverview from './BookOverview.vue'
import InnerSearch from '@/components/Shared/Search/InnerSearch.vue'
import BookCategories from './BookCategories.vue'
import BookMostPopularProducts from './BookMostPopularProducts.vue'
import BookTags from './BookTags.vue'
import BookTabs from './BookTabs.vue'
import SimilarProducts from '../SimilarProducts/index.vue'
export default {
  components: {
    InnerPageTitle,
    BookImage,
    BookDescription,
    BookComments,
    BookOverview,
    InnerSearch,
    BookCategories,
    BookMostPopularProducts,
    BookTags,
    BookTabs,
    SimilarProducts,
  },
  data() {
    return {
      tab: 'BookOverview',
    }
  },
  props: {
    product: {
      default: () => {},
    },
  },
}
